import {$api} from "./$api";
import {AxiosResponse} from 'axios'
import {IModuleResponse} from "./models/IModuleResponse";
import {ModuleOrderDto} from "./dto/modules/orders.dto";

export const modulesApi = {
    uploadImage(image: any) {
        return $api.post('/modules/image', image, {
            headers: {
                'content-type': 'multipart/form-data'
            }
        })
    },
    getModules(): Promise<AxiosResponse<IModuleResponse[]>> {
        return $api.get<IModuleResponse[]>('/modules')
    },
    updateOrders(orders: ModuleOrderDto[]): Promise<AxiosResponse<string>> {
        return $api.patch<string>('/modules/update_orders', orders)
    },

    sendModuleData(form: any): Promise<AxiosResponse<IModuleResponse>> {
        return $api.post<IModuleResponse>('/modules', form, {
            headers: {"Content-Type": "multipart/form-data"}
        })
    },

    deleteModule(id: number): Promise<AxiosResponse<string>> {
        return $api.delete<string>('/modules', {data: {id}})
    }


}
